import * as actionTypes from "../../actions/actionTypes";

const updatedObject = (oldObject, updatedValue) => {
  return {
    ...oldObject,
    ...updatedValue,
  };
};

const initialState = {
  error: null,
  isLoading: false,
  show: false,
};

const apiStart = (state, action) => {
  return updatedObject(state, { ...action, isLoading: true });
};

const apiSuccess = (state, action) => {
  return updatedObject(state, {
    error: null,
    isLoading: false,
    show: false,
  });
};

const apiFail = (state, action) => {
  return updatedObject(state, {
    isLoading: false,
    error: action.error,
  });
};

const clearError = state => {
  return updatedObject(state, {
    error: null,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.API_START:
      return apiStart(state, action);
    case actionTypes.API_SUCCESS:
      return apiSuccess(state, action);
    case actionTypes.API_FAIL:
      return apiFail(state, action);
    case actionTypes.CLEAR_ERROR:
      return clearError(state);
    default:
      return state;
  }
};

export default reducer;
